import { ComponentAPI } from '@philips-internal/oswald-ui-core';
class ProgressBarAPI extends ComponentAPI {
    getPercentage() {
        return this.state.percentage;
    }
    setPercentage(percentage) {
        this.setState({ percentage });
    }
    getMaxParts() {
        return this.state.maxParts;
    }
    setMaxParts(maxParts) {
        this.setState({ maxParts });
    }
    getCurrentPart() {
        return this.state.currentPart;
    }
    setCurrentPart(currentPart) {
        this.setState({ currentPart });
    }
    getLeftText() {
        return this.state.leftText;
    }
    setLeftText(leftText) {
        this.setState({ leftText });
    }
    getRightText() {
        return this.state.rightText;
    }
    setRightText(rightText) {
        this.setState({ rightText });
    }
}
export default ProgressBarAPI;
//# sourceMappingURL=progress-bar-api.js.map